import { type StyleValue } from "vue";

export interface WLBaseExpandableProps {
  expandableClasses?: StyleValue;
  isOpen?: boolean;
  isDisabled?: boolean;
  initialState?: {
    isOpen: boolean;
  };
}

export interface WLBaseExpandableEmits {
  (event: "isOpen", value: boolean): void;
  (event: "beforeOpen"): void;
  (event: "afterOpen"): void;
  (event: "beforeClose"): void;
  (event: "afterClose"): void;
}
